<template>
    <div class="duo-input">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "DuoInput"
    }
</script>

<style scoped lang="scss">
    @include screen-xs{
        .duo-input{
            display:grid;
            grid-template-columns: 1fr 1fr;
            gap:24px;
        }
    }
</style>
